import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AlarmNotificationListService } from '../../../../../core/alarms/_services/alarm-notification-list.service';
import { currentUser, User } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { ProductService } from '../../../../../core/plant-configuration';
import { ProductPackageUnitService } from '../../../../../core/plant-configuration/_services/product-package-unit.service';
import { ProductPackageWeightService } from '../../../../../core/plant-configuration/_services/product-package-weight.service';
import { ProductPackageService } from '../../../../../core/plant-configuration/_services/product-package.service';
import { ProductProcessService } from '../../../../../core/plant-configuration/_services/product-process.service';
import { ProductTypeService } from '../../../../../core/plant-configuration/_services/product-type.service';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-notification-list-list',
	templateUrl: './notification-list-list.component.html',
	styleUrls: []
})
export class NotificationListListComponent implements OnInit, OnDestroy, AfterViewInit {


	// displayedColumns = ['select', 'active', 'login', 'group_name','login_date', 'actions'];
	filterList = [
		// {name: 'product_type_id', value: "-1", type: 'list', label: 'Tipo de producto', optionList: []},
		// {name: 'product_packaging_id', value: "-1", type: 'list', label: 'Formato', optionList: []},
		// {name: 'product_process_id', value: "-1", type: 'list', label: 'Proceso', optionList: []},
	];
	columnList = [
		// {name: 'id', displayName: 'ID', def: 'id' },
		{ name: 'name', displayName: 'Nombre', def: 'name' },
		// { name: 'product_type_name', displayName: 'Tipo de producto', def: 'product_type_name'},
		{ name: 'create_date', displayName: 'Fecha de creación', def: 'create_date', isDate: true},
		{ name: 'write_date', displayName: 'Fecha de modificación', def: 'write_date', isDate: true},
	];
	actionBtns = [];
	inited = false;
	dataObs: Subject<QueryResultsModel> = new Subject<QueryResultsModel>();
	deleteObs: Subject<string> = new Subject<string>();
	subscriptions: Subscription[] = [];
	lastQuery: QueryParamsModel;
	user$: Observable<User>;
	packageList: any[] = [];
	productTypeList: any[] = [];
	processList: any[] = [];
	
	constructor(
		private alarmNofitificationListService: AlarmNotificationListService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef,
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.inited = true;
		this.user$ = this.store.pipe(select(currentUser));
	}

	deleteOne(userId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.alarmNofitificationListService.delete({ id: userId }))
			).subscribe(status => {
				this.deleteObs.next(status);
			})
		);
	}

	getPage(query: QueryParamsModel) {
		// this.lastQuery = Object.assign(query, {filter: Object.assign(query.filter, {is_installation_contact: 'true'})});
		console.log(`query get page: ${JSON.stringify(query)}`);
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.alarmNofitificationListService.getPage(query))
			).subscribe(res => {
				console.log(`query result: ${JSON.stringify(res)}`);
				this.dataObs.next(res);
			})
		);
	}

	refresh() {
		this.getPage(this.lastQuery);
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	ngAfterViewInit() {
	}
}